var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-reservation-feedback"},[_c('VueFeedback',{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v(_vm._s(_vm.t('oops')))]),_c('template',{slot:"feedback-content"},[_c('p',{staticClass:"sf-text"},[_vm._v(_vm._s(_vm.t('technical-error')))])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }